/*
  GiftGo product personalization fields.

  - Enforces the note word limit and shows a live counter.
  - Shows the chosen photo's filename.
  - Removes the name attribute from an empty field so blank line item properties
    never reach the cart (kept editable, unlike disabling). With no JS the fields
    still submit via their name attribute, so this is progressive enhancement.
*/
(function () {
  'use strict';

  function setSubmitted(el, on) {
    var name = el.getAttribute('data-prop-name');
    if (!name) return;
    if (on) {
      if (!el.getAttribute('name')) el.setAttribute('name', name);
    } else {
      el.removeAttribute('name');
    }
  }

  function initText(textarea) {
    var max = parseInt(textarea.getAttribute('data-max-chars'), 10) || 150;
    var counter = textarea.parentNode.querySelector('[data-giftgo-custom-counter]');

    function update() {
      // The textarea's maxlength caps typing; this also guards pasted text.
      if (textarea.value.length > max) textarea.value = textarea.value.slice(0, max);
      var len = textarea.value.length;
      if (counter) {
        counter.textContent = len + ' / ' + max;
        counter.classList.toggle('is-max', len >= max);
      }
      setSubmitted(textarea, textarea.value.trim() !== '');
    }

    textarea.addEventListener('input', update);
    update();
  }

  function initImage(input) {
    var nameEl = input.parentNode.querySelector('[data-giftgo-custom-filename]');
    var fallback = nameEl ? nameEl.textContent : '';

    function update() {
      var has = input.files && input.files.length > 0;
      if (nameEl) nameEl.textContent = has ? input.files[0].name : fallback;
      setSubmitted(input, has);
    }

    input.addEventListener('change', update);
    update();
  }

  function init() {
    document.querySelectorAll('[data-giftgo-custom-text]').forEach(initText);
    document.querySelectorAll('[data-giftgo-custom-image]').forEach(initImage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
